import { Component } from '@verndale/core';
import Choices from 'choices.js';
import { getParameterByName } from '../../helpers';
class NewsList extends Component {
  setupDefaults() {
    this.dom = {
      $window: $(window),
      $form: this.$el.find('.news-filters__form'),
      $viewBtns: this.$el.find('.js-news-list-btn'),
      $dropdown: this.$el.find('.news-filters__dropdown'),
      $select: this.$el.find('.field__select'),
      $keyword: this.$el.find('.news-filters__keyword .field__input'),
      $category: this.$el.find('.news-filters__category .field__select'),
      $date: this.$el.find('.news-filters__date-range .field__select'),
      $spinner: this.$el.find('.spinner'),
      $filters: this.$el.find('.news-filters'),
      $results: this.$el.find('.news-list__results'),
      $noResults: this.$el.find('.news-list__no-results')
    };

    this.url = this.dom.$form.attr('action');
    this.action = this.dom.$form.attr('method') || 'GET';
    this.page = 1;
    this.view = 'grid';

    this.initSelect();
    this.parseUrl();
    this.search(this.page, false);
  }

  parseUrl() {
    const keyword = getParameterByName('keyword') || '';
    const category = getParameterByName('category') || '';
    const date = getParameterByName('date') || '';
    const page = getParameterByName('page') || '1';

    this.dom.$keyword.val(keyword);
    this.categoryChoices.setChoiceByValue(category);
    this.dateChoices.setChoiceByValue(date);

    this.page = parseInt(page, 10);
  }

  initSelect() {
    const config = {
      searchEnabled: false,
      searchChoices: false,
      itemSelectText: '',
      shouldSort: false
    };
    this.categoryChoices = new Choices(this.dom.$category[0], config);
    this.dateChoices = new Choices(this.dom.$date[0], config);
    this.dom.$dropdown.addClass('is-active');
  }

  addListeners() {
    this.dom.$form.on('submit', ::this.handleSubmit);
    this.dom.$category.on('change', ::this.handleSubmit);
    this.dom.$date.on('change', ::this.handleSubmit);
    this.dom.$viewBtns.on('click touchstart', ::this.triggerViewMode);
    this.dom.$results.on(
      'click',
      '.pagination__button--first',
      ::this.handleFirstButtonClick
    );
    this.dom.$results.on(
      'click',
      '.pagination__button--prev',
      ::this.handlePrevButtonClick
    );
    this.dom.$results.on(
      'click',
      '.pagination__button--page',
      ::this.handlePageButtonClick
    );
    this.dom.$results.on(
      'click',
      '.pagination__button--next',
      ::this.handleNextButtonClick
    );
    this.dom.$results.on(
      'click',
      '.pagination__button--last',
      ::this.handleLastButtonClick
    );

    this.dom.$window.on('popstate', ::this.handlePopState);
  }

  triggerViewMode(e) {
    e.preventDefault();
    e.stopPropagation();

    const $activeBtn = $(e.currentTarget);
    const $newsList = this.dom.$results.find('.news-list__list');
    this.dom.$viewBtns.removeClass('is-active');
    $activeBtn.addClass('is-active');
    if ($activeBtn.hasClass('js-list-view')) {
      $newsList.addClass('is-list-view');
      this.view = 'list';
    } else {
      $newsList.removeClass('is-list-view');
      this.view = 'grid';
    }
  }

  handleSubmit(e) {
    e.preventDefault();
    this.search(1);
  }

  handlePopState() {
    this.parseUrl();
    this.search(this.page, false);
  }

  handleFirstButtonClick() {
    this.goToPage(1);
  }

  handlePrevButtonClick() {
    const page = this.page - 1;
    this.goToPage(page);
  }

  handlePageButtonClick(e) {
    const $btn = $(e.currentTarget);
    const page = $btn.data('page');
    this.goToPage(page);
  }

  handleNextButtonClick() {
    const page = this.page + 1;
    this.goToPage(page);
  }

  handleLastButtonClick(e) {
    const $btn = $(e.currentTarget);
    const page = $btn.data('page');
    this.goToPage(page);
  }

  goToPage(page) {
    const scrollTop = this.dom.$filters.offset().top;
    $('html, body').animate({ scrollTop }, 200);
    this.search(page);
  }

  search(page, updateUrl = true) {
    const keyword = this.dom.$keyword.val();
    const category = this.dom.$category.val();
    const date = this.dom.$date.val();
    const filters = { page };

    if (keyword) {
      filters.keyword = keyword;
    }
    if (category) {
      filters.category = category;
    }
    if (date) {
      filters.date = date;
    }

    this.page = page;

    if (updateUrl) {
      const params = $.param(filters);
      let url = location.pathname;

      if (params) {
        url = `${url}?${params}`;
      }

      window.history.pushState({}, null, url);
    }

    this.dom.$noResults.fadeOut();
    this.dom.$results.fadeOut(() => {
      this.dom.$results.empty();
      this.dom.$spinner.addClass('is-active');
      this.dom.$spinner.fadeIn();

      this.getData(filters)
        .then(::this.renderResults)
        .catch(::this.handleErrors);
    });
  }

  getData(filters) {
    return $.ajax({
      url: this.url,
      action: this.action,
      data: filters
    }).then(data => {
      return { filters, data };
    });
  }

  getLabel($select, value) {
    return $select.find(`option[value="${value}"]`).text();
  }

  renderResults(response) {
    const { articles } = response.data;
    let $content;

    if (articles && articles.length) {
      const desc = this.renderDescription(response);
      const list = this.renderList(response);
      const pagination = this.renderPagination(response);

      this.dom.$results.html(`
        ${desc}
        ${list}
        ${pagination}
      `);

      $content = this.dom.$results;
    } else {
      $content = this.dom.$noResults;
    }

    this.dom.$spinner.fadeOut(() => {
      $content.fadeIn();
    });
  }

  scrollToFilters() {
    const scrollTop = this.dom.$filters.offset().top;
    $('html, body').animate({ scrollTop }, 600);
  }

  renderDescription(response) {
    const { total, articles } = response.data;

    const { keyword, category } = response.filters;
    const categoryLabel = this.getLabel(this.dom.$category, category);

    let kc = '';
    if (keyword) {
      kc = `for <b>${keyword}</b> `;
    }
    if (categoryLabel) {
      kc = `${kc}in <b>${categoryLabel}</b>`;
    }

    return /*HTML*/ `
      <div class="news-list__articles-number">
        <span class="news-list__articles-number-text">
          Viewing <b>${articles.length}</b> of <b>${total}</b> results ${kc}
        </span>
      </div>
    `;
  }

  renderList(response) {
    const { data } = response;

    if (data.articles && data.articles.length) {
      const items = data.articles.map(
        item => /*HTML*/ `
        <li class="news-list__item">
          ${this.renderItem(item)}
        </li>
      `
      );

      const classes = ['news-list__list'];

      if (this.view === 'list') {
        classes.push('is-list-view');
      }

      return /*HTML*/ `
        <ul class="${classes.join(' ')}">${items.join('')}</ul>
      `;
    }

    return '';
  }

  renderItem(item) {
    return /*HTML*/ `
        <a href="${item.url}" class="news-card">
          <figure class="news-card__figure">
            <div class="news-card__image-wrapper">
              ${this.renderItemImage(item)}
            </div>
            <figcaption class="news-card__info">
              <em class="news-card__type">${item.type}</em>
              <h4 class="news-card__title">${item.headline}</h4>
              <span class="news-card__date">${item.dateFormatted}</span>
            </figcaption>
          </figure>
      </a>
    `;

    //<div class="news-card__text">${item.mainContentDisplay}</div>
  }

  renderItemImage(item) {
    if (item.imageUrl) {
      return /*HTML*/ `
        <img data-src="${item.imageUrl}"
          alt="${item.headline}"
          class="news-card__image lazyload"
          />
      `;
    }
    return '';
  }

  renderPagination(response) {
    const { total, limit } = response.data;
    const pages = Math.ceil(total / limit);

    if (pages <= 1) {
      return '';
    }

    const numbers = createNumbers(this.page, pages);

    const firstButton = this.renderFirstButton(this.page);
    const prevButton = this.renderPrevButton(this.page);
    const pageButtons = this.renderPageButtons(numbers, this.page);
    const nextButton = this.renderNextButton(this.page, pages);
    const lastButton = this.renderLastButton(this.page, pages);

    return /*HTML*/ `
      <div class="pagination">
        ${firstButton}${prevButton}${pageButtons}${nextButton}${lastButton}
      </div>
    `;
  }

  renderFirstButton(currentPage) {
    const icon = /*HTML*/ `
        <svg>
          <use xlink:href="#first"></use>
        </svg>
      `;
    const classes = ['pagination__button--first'];
    if (currentPage === 1) {
      classes.push('pagination__button--disabled');
    }

    return this.renderButton('first', classes, icon, 'Go to first page');
  }

  renderPrevButton(currentPage) {
    const icon = /*HTML*/ `
        <svg>
          <use xlink:href="#prev"></use>
        </svg>
      `;
    const classes = ['pagination__button--prev'];
    if (currentPage === 1) {
      classes.push('pagination__button--disabled');
    }

    return this.renderButton('prev', classes, icon, 'Go to previous page');
  }

  renderNextButton(currentPage, pages) {
    const icon = /*HTML*/ `
        <svg>
          <use xlink:href="#next"></use>
        </svg>
      `;
    const classes = ['pagination__button--next'];
    if (currentPage === pages) {
      classes.push('pagination__button--disabled');
    }

    return this.renderButton('next', classes, icon, 'Go to next page');
  }

  renderLastButton(currentPage, pages) {
    const icon = /*HTML*/ `
        <svg>
          <use xlink:href="#last"></use>
        </svg>
      `;
    const classes = ['pagination__button--last'];
    if (currentPage === pages) {
      classes.push('pagination__button--disabled');
    }

    return this.renderButton(pages, classes, icon, 'Go to last page');
  }

  renderPageButtons(numbers, currentPage) {
    return numbers.map(num => this.renderPageButton(num, currentPage)).join('');
  }

  renderPageButton(page, currentPage) {
    const classes = [];
    let number;
    if (page === '...') {
      classes.push('pagination__button--ellipsis');
      number = page;
    } else {
      classes.push('pagination__button--page');
      number = page + 1;
    }
    if (number === currentPage) {
      classes.push('pagination__button--active');
    }

    return this.renderButton(number, classes, number);
  }

  renderButton(page, classes, label, ariaLabel) {
    return /*HTML*/ `
      <button type="button"
        aria-label="${ariaLabel ? ariaLabel : label}"
        class="pagination__button ${classes.join(' ')}"
        data-page="${page}">
        ${label}
      </button>
    `;
  }

  handleErrors(error) {
    console.error('error', error);
  }
}

function createNumbers(page, pages) {
  let numbers = [];
  const buttons = 7;
  const half = Math.floor(buttons / 2);

  if (pages <= buttons) {
    numbers = createRange(0, pages);
  } else if (page <= half) {
    numbers = createRange(0, buttons - 2);
    numbers.push('...');
    numbers.push(pages - 1);
  } else if (page >= pages - 1 - half) {
    numbers = createRange(pages - (buttons - 2), pages);
    numbers.splice(0, 0, '...');
    numbers.splice(0, 0, 0);
  } else {
    numbers = createRange(page - half + 2, page + half - 1);
    numbers.push('...');
    numbers.push(pages - 1);
    numbers.splice(0, 0, '...');
    numbers.splice(0, 0, 0);
  }

  return numbers;
}

function createRange(len, start) {
  const out = [];
  let end;

  if (typeof start === 'undefined') {
    start = 0;
    end = len;
  } else {
    end = start;
    start = len;
  }

  for(let i = start; i < end; i++) {
    out.push(i);
  }

  return out;
}

export default NewsList;
